import { render, staticRenderFns } from "./ShopsRanking.vue?vue&type=template&id=7098eba3&scoped=true&"
import script from "./ShopsRanking.vue?vue&type=script&lang=js&"
export * from "./ShopsRanking.vue?vue&type=script&lang=js&"
import style0 from "./ShopsRanking.vue?vue&type=style&index=0&id=7098eba3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7098eba3",
  null
  
)

export default component.exports